import React from 'react'
import { Paper, Slider, Typography } from '@mui/material'
import { useGlobalState } from 'state'
import { MenuType } from 'common/types'

export const OpacityControl = () => {
  const state = useGlobalState()
  const [rasterOpacity, setRasterOpacity] = React.useState(60)

  React.useEffect(() => {
    const val = state.map.layerOpacity[state.app.menu]
    setRasterOpacity(val * 100)
  }, [state.app.menu])

  React.useEffect(() => {
    const obj = {...state.map.layerOpacity}
    obj[state.app.menu] = rasterOpacity / 100
    state.map.setLayerOpacity(obj)
  }, [rasterOpacity])

  const getTitle = (): string => {
    const menu = state.app.menu as MenuType
    if (menu === 'rain') {
      return '降雨レーダーの透明度'
    } else if (menu === 'river-floods') {
      return '浸水範囲計算結果の透明度'
    } else if (menu === 'dosya') {
      return '土砂災害リスクの透明度'
    } else {
      return ''
    }
  }

  return (
    <>
      { state.app.menu !== 'kouzui' && (
        <Paper sx={{width: 160, px: '6px', pt: '6px', pb: '10px'}}>
          <Typography variant='caption' fontSize={'11px'}>{getTitle()}</Typography>
          <Slider
            sx={{p: 0, m: 0}}
            step={10}
            size="small"
            min={0}
            max={100}
            value={rasterOpacity}
            onChange={(e, value) => setRasterOpacity(Number(value))}
          />
        </Paper>
      )}
    </>
  )
}
